import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { select, NgRedux } from '@angular-redux/store';

import { StopsFacade, StopsService, TicketsService } from '@ridango/components';
import { MatDialog } from '@angular/material/dialog';
import { DialogZoneInfoComponent } from '../dialog-zone-info/dialog-zone-info.component';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-stops-zones-selector',
    templateUrl: './stops-zones-selector.component.html',
    styleUrls: ['./stops-zones-selector.component.scss']
})
export class StopsZonesSelectorComponent implements OnInit, OnDestroy {
    @select(['stops', 'filtered']) filteredZones$;
    @select(['stops', 'allAreas']) allZonesSelected$;
    @select(['stops', 'selectedOrigin']) selectedOrigin$;
    @select(['stops', 'selectedDestination']) selectedDestination$;
    @select(['application', 'assetsPath']) assetsPath$;

    @Input() travelBetweenZones = false;
    @Input() step = 1;
    @Input() zonesWithStops = false;
    @Input() mapFile: string;
    @Output() onZoneSelected = new EventEmitter<any>();
    @Output() onBothZonesSelected = new EventEmitter<any>();

    locale = 'en';
    dropdownVisible = false;
    oneZoneSelected = false;
    countySelected = false;
    showWholeCounty = this.env.PURCHASE?.WHOLE_COUNTY_OPTION ?? true;

    constructor(
        @Inject('ENV') private env: Env,
        private stopService: StopsService,
        private stopsFacade: StopsFacade,
        private ngRedux: NgRedux<any>,
        private ticketsService: TicketsService,
        private matDialog: MatDialog
    ) {}

    ngOnInit() {
        if (this.zonesWithStops) {
            this.stopsFacade.getStopsWithZones();
        } else {
            this.stopsFacade.getAllZones();
        }

        // RENEWABLE TICKET
        // const renewableTicket = this.ngRedux.getState().tickets.renewableTicket;
        // if (renewableTicket && renewableTicket.start_zone_id) {
        //     const zone = byId[renewableTicket.start_zone_id];
        //     this.originZoneSelected(zone);
        // } else if (renewableTicket) {
        //     this.toggleWholeCountySelected();
        // }
        // -- RENEWABLE TICKET
    }

    ngOnDestroy() {
        this.originZoneSelected(null);
        this.destinationZoneSelected(null);
    }

    dropdownToggle(e: boolean) {
        this.dropdownVisible = e;
    }

    originZoneSelected(e) {
        this.stopsFacade.setSelectedOrigin(e);
        this.oneZoneSelected = true;
        this.countySelected = false;

        if (!this.travelBetweenZones) {
            this.stopsFacade.setSelectedDestination(e);
        }

        this.stopsFacade.setAllAreasSelected(false);
        this.dropdownVisible = false;
        this.onZoneSelected.emit(false);

        if (this.ngRedux.getState().stops.selectedDestination) {
            this.onBothZonesSelected.emit();
        }
    }

    destinationZoneSelected(e) {
        this.stopsFacade.setSelectedDestination(e);
        this.stopsFacade.setAllAreasSelected(false);

        if (this.ngRedux.getState().stops.selectedOrigin) {
            this.onBothZonesSelected.emit();
        }
    }

    toggleWholeCountySelected() {
        this.stopsFacade.setSelectedOrigin(null);
        this.stopsFacade.setSelectedDestination(null);
        const toggle = !this.ngRedux.getState().stops.allAreas;
        this.stopsFacade.setAllAreasSelected(toggle);
        this.onZoneSelected.emit(toggle);
        this.oneZoneSelected = false;
        this.countySelected = toggle;
    }

    forgetTicketRenew() {
        this.ticketsService.forgetRenewableTicket();
    }

    openMapDialog() {
        this.matDialog.open(DialogZoneInfoComponent, {
            data: {
                mapFile: this.mapFile
            },
            maxWidth: '100%',
            panelClass: 'dialog-wrapper'
        });
    }
}
